import(/* webpackMode: "eager" */ "/home/cararr/Desktop/effectivity/neopak/neopak-forms/src/app/register/page.tsx");
